import Calendario from '../../ComponentesGlobales/Calendario'
import { useStoreIngresos } from './useStoreIngresos'
import ListaDesplegable from '../../ComponentesGlobales/ListaDesplegable'
import { useEffect, useState } from 'react'
import { BlockUI } from 'primereact/blockui'
import { ProgressSpinner } from 'primereact/progressspinner'
import qr from "../../icons/qr.png"
import { MensajeToastError, MensajeToastAdvertencia } from '../../componentes/FuncionesLocales'
import { useStoreEntrada } from '../Produccion-Entradas/useStoreEntradas'
import { useStoreHome } from "../Home/useStoreHome";
import ScannerUnico from '../../ComponentesGlobales/ScannerUnico'

export default function IngresosTab1() {
  const Fecha = useStoreIngresos((state) => state.Fecha);
  const FechasConIngresos = useStoreIngresos((state) => state.FechasConIngresos);
  const Remito = useStoreIngresos((state) => state.Remito);
  const Proveedor = useStoreIngresos((state) => state.Proveedor);
  const ListaProveedores = useStoreIngresos((state) => state.ListaProveedores);
  const buscandoProveedores = useStoreIngresos((state) => state.buscandoProveedores); 
  const EsProductoTerminado = useStoreIngresos((state) => state.EsProductoTerminado);

  const BuscandoCodbar = useStoreEntrada((state) => state.BuscandoCodbar);
  const CodbarLeido = useStoreEntrada((state) => state.CodbarLeido);
  const deviceConsentimiento = useStoreHome((state) => state.deviceConsentimiento);
  const [showQRScanner, setShowQRScanner] = useState(false);
  

  
 useEffect(() => {
    useStoreIngresos.getState().getFechas();
  }, []);

  
   // Manejar el escaneo del QR
    const [Entrolectura, setEntroLectura] = useState(false);
    const [lastQrValue, setLastQrValue] = useState(''); // Para evitar lecturas duplicadas del mismo código

    const handleQRScan = (result) => {
        // Verificaciones para evitar doble escaneo
        if (Entrolectura) {
            console.log('🚫 Escaneo bloqueado: procesando lectura anterior');
            return;
        }

        // Evitar el mismo código QR en un corto período de tiempo
        if (lastQrValue === result) {
            console.log('🚫 Escaneo bloqueado: mismo código QR reciente');
            return;
        }

        setEntroLectura(true);
        setLastQrValue(result);

        try {
            useStoreEntrada.setState({ CodbarLeido: { sCodbar: result } });
            setShowQRScanner(false);

            useStoreEntrada.getState().getCodbar(result)


        } catch (error) {
            console.error('Error al procesar el QR escaneado:', error);
            MensajeToastError('Ocurrió un error al procesar el código QR.', 4000);
        } finally {
            // Permitir nuevo escaneo después de un retraso más largo
            setTimeout(() => {
                setEntroLectura(false);
                // console.log('✅ Listo para nuevo escaneo');
            }, 1500);

            // Limpiar el último QR después de un tiempo para permitir re-escaneo del mismo código
            setTimeout(() => {
                setLastQrValue('');
                // console.log('🔄 Cache de QR limpiado');
            }, 5000);
        }
    };


    const openQRScanner = () => {
        if (deviceConsentimiento !== "granted") {
            MensajeToastAdvertencia("Habilitá permisos en el Home para usar la cámara.", 3000);
            return;
        }
        if (!window.isSecureContext) {
            MensajeToastAdvertencia("La cámara funciona solo en https o localhost (no en 192.168.x.x http).", 4000);
            return;
        }
        if (!navigator.mediaDevices?.getUserMedia) {
            MensajeToastError("Tu navegador no soporta acceso a cámara.", 3000);
            return;
        }
        setShowQRScanner(true);
    };


    const closeQRScanner = () => {
        console.log('🚪 Cerrando QR Scanner desde EntradasTab1...');
        setShowQRScanner(false);

        // Limpieza adicional de seguridad para cualquier video elemento que pueda quedar
        setTimeout(() => {
            try {
                const videos = Array.from(document.querySelectorAll("video"));
                // console.log(`🧹 Limpieza de seguridad: encontrados ${videos.length} elementos video`);

                videos.forEach((video) => {
                    const stream = video.srcObject;
                    if (stream?.getTracks) {
                        const tracks = stream.getTracks();
                        tracks.forEach(track => {
                            if (track.readyState === 'live') {
                                track.stop();
                                //console.log(`🔴 Track ${index}-${track.kind} detenido en limpieza de seguridad`);
                            }
                        });
                    }
                    // Limpiar el video element
                    video.srcObject = null;
                    video.src = '';
                });

                // console.log('✅ Limpieza de seguridad completada');
            } catch (error) {
                console.warn("No se pudo completar la limpieza de la cámara:", error);
            }
        }, 100); // Pequeño delay para asegurar que el componente se desmonte primero
    };


  


  return (
    <div className="ing-bloque-form">
      <div className="bloque-cabecera">
        <h4 className="ing-subtitulo">Procedencia</h4>
        <div className="btns">
          <button className="btn-limpiar" title='Limpiar campos' onClick={useStoreIngresos.getState().limpiezaTotal}>
            <i className="pi pi-eraser" aria-hidden="true" /><span>Limpiar</span>
          </button>
        </div>
      </div>
      <div className="ing-fila-flex">
        <div className="ing-campo">
          <label htmlFor="tipoIngreso">Tipo de ingreso:</label>
          <select
            id="tipoIngreso"
            value={EsProductoTerminado ? "terminado" : "insumo"}
            onChange={(event) => useStoreIngresos.setState({
              EsProductoTerminado: event.target.value === "terminado",
              Cantidad: 1,
              Peso: 0,
              PrecioCosto: 0,
              PrecioVenta: 0,
              PorcentajeIVA: 21,
            })}
          >
            <option value="insumo">Materia prima / insumo</option>
            <option value="terminado">Producto terminado</option>
          </select>
        </div>
        <div className="ing-campo">
          <div className="camp-o">
            {Fecha === "" && <span className="mensaje-obligatorio">*</span>}
            <label htmlFor="fecha">Fecha de ingreso:</label>
          </div>
          <div className="calendario ing-calendario-completo">
            <Calendario
              Fecha={Fecha}
              setFecha={(fecha) => useStoreIngresos.setState({ Fecha: fecha })}
              highlightedDates={FechasConIngresos}
              
            />
          </div>
        </div>

        <BlockUI blocked={BuscandoCodbar}
                    template={<ProgressSpinner style={{ width: '24px', height: '24px', color: "white" }} strokeWidth="8" animationDuration="5.15s" />} >

                    <div className="desp-campo-qr entradas">
                        <input
                            type="text"
                            readOnly={true}
                            placeholder={CodbarLeido?.sCodbar || "Escanear QR"}
                            value={CodbarLeido ? CodbarLeido.sCodbar : ""}
                            className="input-qr"
                        />
                        <img
                            src={qr}
                            alt="qr"
                            className="qr clickable"
                            onClick={deviceConsentimiento === "granted" ? openQRScanner : undefined}
                            title={deviceConsentimiento === "granted" ? "Abrir escáner QR" : "Necesita permiso en Home"}
                            style={{ cursor: deviceConsentimiento === "granted" ? "pointer" : "not-allowed", opacity: deviceConsentimiento === "granted" ? 1 : 0.4 }}
                        />
                    </div>
                    {CodbarLeido?.sCodbar && <h5 style={{ marginBottom: '8px', color: 'red', fontSize: '10px', alignSelf: 'center', width: '100%' }}>Se ingresara este codigo Id: {CodbarLeido.IndentificadorId}</h5>}
                </BlockUI>

        <div className="ing-campo">
          <div className="camp-o">
            {Remito.trim() === "" && <span className="mensaje-obligatorio">*</span>}
            <label htmlFor="remito">N° de Remito:</label>
          </div>
          <input
            type="text"
            name="remito"
            placeholder="0001-000001"
            value={Remito}
            onChange={(e) => useStoreIngresos.setState({ Remito: e.target.value })}
            required
            autoComplete="off"
          />
        </div>

        <div className="ing-campo" >
          <div className="camp-o" >
            {String(Proveedor) === "" && <span className="mensaje-obligatorio">*</span>}
            <label htmlFor="proveedor">Proveedor:</label>
          </div>
          <div className="campo-proveedor">
            <ListaDesplegable Lista={ListaProveedores} Buscando={buscandoProveedores}
              setValor={(e) => useStoreIngresos.setState({ Proveedor: e })}
              Seleccionado={Proveedor} TituloNoSeleccionado={"Nuevo Proveedor"} />
          </div>
        </div>
      </div>
       {showQRScanner && (
                  <ScannerUnico
                      isActive={showQRScanner && !Entrolectura}
                      onScan={!Entrolectura ? handleQRScan : null}
                      onClose={closeQRScanner}
                  />
                  )} 
    </div>
  )
}
